import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useState } from "react";
import { useIntl } from "react-intl";
import { getClientsReports } from "../../../network/Reports";
import { queryKeys } from "../../../services/react-query/queryKeys";
import BodyList from "../BodyList";
import HeaderList from "../HeaderList";
import HeaderTable from "../HeaderTable";
import LayoutReports from "./LayoutReports";
type Props = {};

const CustomerReports = (props: Props) => {
  const [page, setPage] = useState(1);

  const intl = useIntl();
  const cols = [
    intl.formatMessage({ id: "id" }), // for "id"
    intl.formatMessage({ id: "clientName" }), // for "client_name"
    intl.formatMessage({ id: "gender" }), // for "gender"
    intl.formatMessage({ id: "email" }), // for "email"
    intl.formatMessage({ id: "addedOn" }), // for "added_on"
    intl.formatMessage({ id: "phone" }), // for "phone"
    intl.formatMessage({ id: "firstAppointmentDate" }), // for "first_appointment_date"
    intl.formatMessage({ id: "lastAppointmentDate" }), // for "last_appointment_date"
  ];
  const { data, isLoading } = useQuery([queryKeys?.reports, page], () =>
    getClientsReports({ type: "client-list", page })
  );
  const FormattedList = (data: any) => {
    return data?.data?.map((x: any) => {
      return {
        id: x?.id,
        client_name: x?.client_name,
        gender: x?.gender,
        email: x?.email,
        added_on: dayjs(x?.added_on).format("DD-MM-YYYY HH:mm"),
        phone: x?.phone,
        first_appointment_date: x?.first_appointment_date,
        last_appointment_date: x?.last_appointment_date,
      };
    });
  };
  console.log(data);

  return (
    <LayoutReports>
      <HeaderTable />
      <div className="mt-8 overflow-auto">
        <HeaderList cols={cols} />
        <BodyList data={FormattedList(data)} page={page} setPage={setPage} />
      </div>
    </LayoutReports>
  );
};

export default CustomerReports;
